export const D37 = {
    "columns": 6,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "bar",
        "title": "Customer Group Sales",
        "colorTheme": 'colorTheme2',
        "orientation": "horizontal",
        "xAxis": "Sales",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    }
                ],
                "title": "CustomerGroup",
                "endpoint": "D37",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "CustomerGroup",
                        "selectedTitle": "Product",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 3,
                                "visual": {
                                    "id": 1,
                                    "type": "bar",
                                    "title": "Products",
                                    "colorTheme": 'colorTheme2',
                                    "orientation": "horizontal",
                                    "xAxis": "Sales",
                                    "yAxis": "",
                                    "binding": {
                                        "data": {
                                            "series": [
                                                {
                                                    "name": 'Sales',
                                                    "value": 'ActualSales',
                                                    "type": 'column'
                                                }
                                            ],
                                            "title": "ItemName",
                                            "endpoint": "D37.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "CustomerGroup", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {

                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}